<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()" class="closeBtn ">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'library.mealSelect.title' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-searchbar [(ngModel)]="searchTerm" [placeholder]="'general.searchType' | translate:{type: ('general.presetMeals' | translate)}"></ion-searchbar>

  <ion-list>
    <ion-item class="ion-no-padding" *ngFor="let meal of getFilteredMeals();let i = index">
      <ion-label>{{meal.title}}</ion-label>
      <ion-button (click)="selectMeal(meal)">{{ 'general.select' | translate }}</ion-button>
    </ion-item>
  </ion-list>

</ion-content>